module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="hotelReviewContent">\n	<div class="hotelReviewUser" itemprop="author">\n		<span>'+
((__t=( user ))==null?'':__t)+
'</span>\n		<div itemprop="dateCreated" content="'+
((__t=( created.format('YYYY-MM-DD') ))==null?'':__t)+
'" datetime="'+
((__t=( created.format() ))==null?'':__t)+
'"\n			 class="hotelReviewDate">'+
((__t=( created.calendar() ))==null?'':__t)+
'</div>\n	</div>\n	<div itemprop="reviewBody" class="hotelReviewText">'+
((__t=( shortText ))==null?'':__t)+
'</div>\n	';
 if(showPreview) { 
__p+='\n	<div class="hotelReviewFullText">'+
((__t=( text ))==null?'':__t)+
'</div>\n	';
 } 
__p+='\n\n	';
 if(showPreview) { 
__p+='\n	<div class="reviewReadMore show">\n		<span>Читать далее</span>\n	</div>\n	<div class="reviewReadLess"><span>Свернуть</span></div>\n	';
 } 
__p+='\n</div>\n';
 if(Math.floor(rate) != 0) { 
__p+='\n<div class="hotelReviewScoreWrapper">\n	<div class="overallScore">\n		<span itemprop="reviewRating" class="scoreValue r'+
((__t=( Math.floor(rate)))==null?'':__t)+
'">'+
((__t=( rate ))==null?'':__t)+
'<br></span>\n		<span class="overallValueMax">из 5</span>\n	</div>\n	<div class="serviceScoreWrap">\n		';
 if(serviceRate > 0) { 
__p+='\n		<div class="serviceScore r'+
((__t=( Math.floor(serviceRate) ))==null?'':__t)+
'">\n			<div class="scoreTitle">Обслуживание</div>\n			<div class="scoreLinesWrapper ">\n				';
 _(serviceRate).times(function(){ 
__p+='\n				<span class="scoreLine"></span>\n				';
 }) 
__p+='\n				';
 _(5-serviceRate).times(function(){ 
__p+='\n				<span class="scoreLineDefault"></span>\n				';
 }) 
__p+='\n			</div>\n		</div>\n		';
 } 
__p+='\n		';
 if(locationRate > 0) { 
__p+='\n		<div class="locationScore r'+
((__t=( Math.floor(locationRate) ))==null?'':__t)+
'">\n			<div class="scoreTitle">Размещение</div>\n			<div class="scoreLinesWrapper ">\n				';
 _(locationRate).times(function(){ 
__p+='\n				<span class="scoreLine"></span>\n				';
 }) 
__p+='\n				';
 _(5-locationRate).times(function(){ 
__p+='\n				<span class="scoreLineDefault"></span>\n				';
 }) 
__p+='\n			</div>\n		</div>\n		';
 } 
__p+='\n		';
 if(mealRate > 0) { 
__p+='\n		<div class="mealScore r'+
((__t=( Math.floor(mealRate) ))==null?'':__t)+
'">\n			<div class="scoreTitle">Питание</div>\n			<div class="scoreLinesWrapper ">\n				';
 _(mealRate).times(function(){ 
__p+='\n				<span class="scoreLine"></span>\n				';
 }) 
__p+='\n				';
 _(5-mealRate).times(function(){ 
__p+='\n				<span class="scoreLineDefault"></span>\n				';
 }) 
__p+='\n			</div>\n		</div>\n		';
 } 
__p+='\n	</div>\n\n</div>\n';
 } 
__p+='';
}
return __p;
};
